import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IoCartOutline } from 'react-icons/io5';
import { useCart } from '../../contexts/cart';

const CartBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { totalItems } = useCart();

  // Mobile-only oval bar
  if (totalItems === 0) { return null; } // only show if at least 1 item

  return (
    <div
      className="lg:hidden fixed left-1/2 transform -translate-x-1/2 z-30"
      style={{ bottom: 'calc(2.75rem + env(safe-area-inset-bottom, 0px))' }}
    >
      <button
        onClick={() => navigate('/checkout')}
        className="flex items-center gap-2 bg-black text-white rounded-full px-5 py-3 shadow-lg"
      >
        <IoCartOutline className="w-6 h-6" />
        <span className="text-sm font-medium">{t('Checkout')}</span>
        <span className="text-sm font-bold">•</span>
        <span className="text-sm font-medium">{totalItems}</span>
      </button>
    </div>
  );
};

export default CartBar;
